import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Tag } from 'antd';
import { LogoutButton } from './LogoutButton';
import { HistoryButton } from './HistoryButton';

interface NimbusLogoProps {
  className?: string;
}

interface LogoSvgProps {
  className?: string;
  onClick: () => void;
}

const LogoSvg: React.FC<LogoSvgProps> = ({ className, onClick }) => (
  <img
    src="/nimbus.svg"
    alt="Nimbus"
    className={className}
    onClick={onClick}
    style={{ cursor: 'pointer' }}
  />
);

export const NimbusLogo: React.FC<NimbusLogoProps> = ({ 
  className = ''
}) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const showVersion = searchParams.get('showVersion') === 'true';

  const handleClick = () => {
    navigate('/');
  };

  const svg = (
    <LogoSvg
      className={className}
      onClick={handleClick}
    />
  );

  const logoContent = showVersion ? (
    <div style={{ display: 'inline-flex', alignItems: 'center', gap: '30px' }}>
      <Tag color="blue" style={{ fontSize: '12px', fontWeight: 'bold' }}>
        v26
      </Tag>
      {svg}
    </div>
  ) : (
    svg
  );

  return (
    <div style={{ 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      width: '100%',
      position: 'relative'
    }}>
      <div style={{ 
        position: 'absolute', 
        left: 0
      }}>
        <LogoutButton />
      </div>
      
      <div>
        {logoContent}
      </div>
      
      <div style={{ 
        position: 'absolute', 
        right: 0
      }}>
        <HistoryButton />
      </div>
    </div>
  );
};
